import React from 'react';
import { sortObjectsByDateDesc } from '../../utils/helpers';
import theme from '../../theme';

function StatisticsTable({ data }) {
    if (!data || data.length === 0) return <p className={theme.textMuted}>Loading..</p>;

    return (
        <div className="p-0 h-64 overflow-y-auto">
            <table className={`min-w-full bg-white ${theme.cardBorder} rounded-xl shadow-sm overflow-hidden`}>
                <thead className={`sticky top-0 ${theme.tableHeader} border-b ${theme.tableBorder}`}>
                    <tr>
                        {Object.keys(data[0]).map((key) => (
                            <th
                                key={key}
                                className={`py-3 px-4 text-left ${theme.tableHeadText} text-xs font-semibold uppercase tracking-wider`}
                            >
                                {key}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {sortObjectsByDateDesc(data).map((item, index) => (
                        <tr
                            key={index}
                            className={`${index % 2 === 0 ? theme.tableRowAlt : 'bg-white'} ${theme.tableRowHover} transition-colors`}
                        >
                            {Object.values(item).map((value, idx) => (
                                <td
                                    key={idx}
                                    className={`py-2 px-4 border-b ${theme.tableBorder} ${theme.tableText} text-sm`}
                                >
                                    {value}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default StatisticsTable;